module.exports = __webpack_public_path__ + "media/images/icon-initials-white-470bd6ad.svg";